// extracted by mini-css-extract-plugin
export default {"title":"YDspGImxU518Ff5UecL6","suppressed":"qq7apeNgu8Z1PVZdvLov","detections":"gHdN_bZc4K4Sin6nF4zx","detection":"s86NtI1DSIEbH_0p7xQ9","suppressed-note":"aQHQ9h13CQmQeWneXiuz"};